import { Button } from '../Button';
import { BUTTON_SIZE_MAP } from '../Button/mode';
import { styled } from '../styled';

export const IconButtonStyles = styled(Button)(({ sizeVariant = 'l' }) => ({
  padding: 0,
  minWidth: 'auto',

  width: BUTTON_SIZE_MAP[sizeVariant],

  '.MuiButton-startIcon': {
    margin: 0,
  },
}));
